<template>
    <div v-if="show"
         class="alert alert-success alert-dismissible"
    >
        <h5>
            <i class="icon fas fa-check"></i>
            <span>L'établissement d'une DUE pour Cadres et Non Cadres impose de faire
                obligatoirement deux versions. Veuillez créer une DUE pour
                la 2è catégorie de bénéficiaires.</span>
        </h5>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            showBeneficiaryCoverageMessage: 'showBeneficiaryCoverageMessage',
        }),
        show() {
            return this.$route.name === 'due-list' && this.showBeneficiaryCoverageMessage;
        }
    }
}
</script>

<style scoped lang="scss">
    .alert {
        border-radius: 12px;
    }
</style>